module.exports = __webpack_public_path__ + "img/illustration-empty.3ebd7eda.svg";